/**
 * @module
 */
module.exports = {
  SELECTOR_POLLING_MAX_TIME: 2000,
  CHANGE_DATA_KEY: 'optimizelyChangeData',
  CHANGE_ID_ATTRIBUTE_PREFIX: 'data-optly-',
};
